import { Config } from '../config/env';

const { tenantId } = Config;

export const URL = {
  LIBRARY_TAGS_TREE: `v1/library/${tenantId}/tags/tree`,
  LIBRARY_RESOURCES: `v1/library/${tenantId}/resources`,
  LIBRARY_RESOURCE_DETAILS: `v1/library/${tenantId}/resources/:id`,
};
